import { Component } from 'react';
import InputText from './input-text';
import FormErrorList from './form-error-list';
import HelpIcon from '@tradera/blueprint/theme/icons/help.svg?jsx';
import { Button } from 'tradera/components/atoms/button/button';

export default class FormField extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showHint: false
        };
    }

    componentDidMount() {
        const { form, field } = this.props;
        if (!form.fields[field]) {
            form.setFromUserInput(field, '');
        }
    }

    toggleHint() {
        this.setState({
            showHint: !this.state.showHint
        });
    }

    handleHintClick = (event) => {
        event.preventDefault();
        this.toggleHint();
    };

    handleBlur(field) {
        this.props.form.attempt(field);
    }

    fieldState(form, field) {
        const formField = form.fields[field] || {
            isValid: false,
            isValidationEnabled: false
        };
        const classNames = ['input-text'];
        const icon = null;
        if (formField.isValidationEnabled && formField.isValidationPending) {
            classNames.push('input-text-validation-pending');
        } else if (formField.isValidationEnabled && !formField.isValid) {
            classNames.push('is-invalid');
        } else if (formField.isValid) {
            classNames.push('is-valid');
        }
        return {
            classNames: classNames.join(' '),
            icon
        };
    }

    render() {
        const {
            form,
            field,
            hint,
            inputComponent,
            placeholder,
            className,
            containerClassName,
            ...otherProps
        } = this.props;
        const { showHint } = this.state;
        const Input = inputComponent || InputText;
        const fieldState = this.fieldState(form, field);

        return (
            <div className={containerClassName}>
                <div className="d-flex align-items-center">
                    <div className="flex-grow-1">
                        <div className="form-control-with-icon">
                            <Input
                                className={`form-control ${className || ''} ${
                                    fieldState.classNames || ''
                                }`}
                                placeholder={placeholder}
                                name={field}
                                value={form.get(field) || ''}
                                onChange={(e) =>
                                    form.setFromUserInput(
                                        field,
                                        e.currentTarget.value
                                    )
                                }
                                onBlur={() => this.handleBlur(field)}
                                {...otherProps}
                            />
                            {fieldState.icon}
                        </div>
                    </div>
                    {hint && (
                        <Button
                            theme="link"
                            tabIndex="-1"
                            className="d-block flex-grow-0 ml-1"
                            onClick={this.handleHintClick}>
                            <HelpIcon
                                className={`icon icon-md icon-black align-middle`}
                                style={{ pointerEvents: 'none' }}
                            />
                        </Button>
                    )}
                </div>
                {hint && showHint && (
                    <div className="tooltip tooltip-info tooltip-southwest mt-2">
                        <p className="mb-0">
                            <em>{hint}</em>
                        </p>
                    </div>
                )}
                <FormErrorList
                    form={form}
                    field={field}
                    data-field-error={field}
                />
            </div>
        );
    }
}
